import { call, put, takeEvery } from "redux-saga/effects"

import { GET_FACULTIES, ADD_NEW_FACULTY, UPDATE_FACULTY, DELETE_FACULTY } from "./actionTypes";
import {
    getFacultiesSuccess,
    getFacultiesFail,
    addFacultySuccess,
    addFacultyFail,
    updateFacultySuccess,
    updateFacultyFail,
    deleteFacultySuccess,
    deleteFacultyFail,
   
} from "./actions"

import {
    getFaculties,
    addNewFaculty,
    updateFaculty,
    deleteFaculty,
   
} from "helpers/faculties/faculties_backend_helper";
import { toast } from "react-toastify";

function* fetchFaculties() {
    try {
        const response = yield call(getFaculties)
        yield put(getFacultiesSuccess(response))
    } catch (error) {
        yield put(getFacultiesFail(error))
    }
}

function* onAddNewFaculty({ payload }) {
    try {

        
        const response = yield call(addNewFaculty, payload)

        console.log("RESPONSE:", response);
        yield put(addFacultySuccess(response.faculty))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addFacultyFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateFaculty({ payload: data }) {
    try {
        const response = yield call(updateFaculty, data)
        yield put(updateFacultySuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateFacultyFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateFaculty({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateFaculty, payload)
        yield put(updateFacultySuccess(response.faculty))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateFacultyFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteFaculty({ payload: data }) {

    try {
        const response = yield call(deleteFaculty, data)
        yield put(deleteFacultySuccess(response.facultyId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteFacultyFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* facultySaga() {
    yield takeEvery(GET_FACULTIES, fetchFaculties)
    yield takeEvery(ADD_NEW_FACULTY, onAddNewFaculty)
    yield takeEvery(UPDATE_FACULTY, onUpdateFaculty)
    yield takeEvery(DELETE_FACULTY, onDeleteFaculty)
}

export default facultySaga;